import { escapeHtml } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { sanitizeEmailHtml } from '../../../Scheduling/flows/emailHtml'
import { CHIP_CLASSES } from './nodes/VariableNode'

const VARIABLE = /\{\{\s*([a-z_][a-z0-9_]*)[^}]*\}\}/g
const LOGIC = /<!--\{%-?[\s\S]*?-?%\}-->|\{%-?[\s\S]*?-?%\}|<!--[\s\S]*?-->/g

export const lockedHtmlForEditor = (html: string, labels: Map<string, string>): string => {
  const marked = html
    .replace(LOGIC, '')
    .split(/(<[^>]*>)/)
    .map((part) =>
      part.startsWith('<')
        ? part.replace(VARIABLE, '#')
        : part.replace(VARIABLE, (_match, name: string) => `<span class="${CHIP_CLASSES.join(' ')}">${escapeHtml(labels.get(name) ?? name)}</span>`),
    )
    .join('')
  const rows = /^\s*<tr[\s>]/i.test(marked) ? `<table width="100%"><tbody>${marked}</tbody></table>` : marked
  return sanitizeEmailHtml(rows, { neutralizeLinks: true })
}
